<template> 
    <div > 
        <div class="crumbs" hidden="true" style="margin-left:10px;" >
            <el-breadcrumb separator="/">
                <el-breadcrumb-item><i class="el-icon-lx-calendar"></i> 商品管理
                </el-breadcrumb-item>
                 <el-breadcrumb-item>产品配置</el-breadcrumb-item>
            </el-breadcrumb>
        </div> 
        <div class="container" v-loading="loading2" element-loading-text="正在保存商品数据" element-loading-spinner="el-icon-loading">  
             <el-collapse accordion style="padding:0px 30px 10px 0px;background-color:#fff; margin-top:-25px">
                <el-collapse-item>
                    <template slot="title">
                        <div  style="font-size:18px;"> <i class="header-icon el-icon-info" style="color:#F56C6C;margin-right:10px;"></i>配置说明</div>
                    </template>
                    <div style="font-size:14px;color:#333;"> <pre>
        1.权重值设置：在 0 - 10 之间
        2.进单分配规则：如果用户同时满足办理A、B两款产品，A的权重为1，B的权重为4。则A的进单量为20%，B的进单两为80%
        3.权重值为0：不进单  </pre>

                    </div> 
                </el-collapse-item>
            </el-collapse>   
            <div  style="border: 1px dashed #409EFF;background:#ecf5ff;padding:15px 10px;margin-top:-15px;"> 
                     <span class="label-span">
                    <label class="label2">上游资源</label> 
                    <el-select v-model="query2.channelCode"  placeholder="资源名称" filterable  clearable class="handle-select mr10">
                        <el-option value="" label="全部"  />  
                        <el-option v-for="item in select6.option" :key="item.id" :label="item.optVal" :value="item.optKey" /> 
                    </el-select>
                </span>   
                <span class="label-span">
                    <label class="label2">产品编码</label> 
                    <el-input v-model.trim="query2.sonCode" placeholder="系统产品编码" style="width:120px;" class="handle-input mr10"></el-input> 
                </span>     
                <span class="label-span">
                    <label class="label2">产品名称</label> 
                    <el-input v-model.trim="query2.goodsName" placeholder="系统产品编码" style="width:120px;" class="handle-input mr10"></el-input> 
                </span>      
                    <el-button type="success" size="small" @click="handleSearch2">搜索</el-button>
                    <el-button type="warning" size="small" @click="refreshSearch2">重置</el-button> 
                    <el-tooltip  content="点击解开编辑权限" placement="top">
                        <i style="color:#fff;font-size:25px;vertical-align:middle;cursor:pointer;color: #409eff;float:right;margin-right:20px;" class='el-icon-edit-outline'  @click="setConfigEdit()"></i>
                    </el-tooltip>

                <el-table   :data="tableData2" stripe="true" size="mini" border class="table" header-cell-class-name="table-header"  
                v-loading="loading4" style="margin-top:15px"  element-loading-text="请稍等..." element-loading-spinner="el-icon-loading" >  
                    <el-table-column prop="channelName" min-width="120" align="left" label="上游资源"></el-table-column> 
                    <el-table-column prop="sonCode" min-width="120" align="center" label="产品编码"></el-table-column> 
                    <el-table-column prop="goodsName" min-width="220" align="left" label="产品名称"></el-table-column>  
                    <el-table-column prop="isp" min-width="80" align="center" label="计费通道">
                        <template slot-scope="scope" >
                            <el-tag :style="scope.row.isp==1?'background:#409eff;color:#fff;':scope.row.isp==2?'background:#fd7a7a;color:#fff;':scope.row.isp==3?'background:#3f3d3d;color:#fff;':scope.row.isp==0?'background:#2ade6e;color:#fff;':scope.row.isp==9?'background:#ed5fbe;color:#fff;':'background:#999;color:#fff;'">
                                {{scope.row.isp==1?'移动':scope.row.isp==2?'联通':scope.row.isp==3?'电信':scope.row.isp==0?'自收款':scope.row.isp==9?'代收款':'其它'}}
                                </el-tag>
                         </template>
                    </el-table-column> 
                    <el-table-column prop="goodsRate" min-width="80" align="left" label="产品资费">
                        <template slot-scope="scope" >
                             <span class="red">￥{{scope.row.goodsRate}}</span>
                         </template>
                    </el-table-column> 
                    <el-table-column prop="goodsName" min-width="100" align="left" label="冷静期">
                        <template slot-scope="scope" >
                            {{scope.row.coolTime}} <span v-if="scope.row.coolTime">分钟</span>
                         </template>
                    </el-table-column> 
                    <el-table-column prop="goodsName" min-width="110" align="center" label="投放时间">
                        <template slot-scope="scope" >
                            {{scope.row.promoteStart}} - {{scope.row.promoteEnd}} 
                         </template>
                    </el-table-column> 
                    <el-table-column prop="goodsName" min-width="110" align="left" label="上游佣金">
                        <template slot-scope="scope" >
                            <span class="red">￥{{scope.row.channelCom}}<span v-if="scope.row.channelComType==2"> * {{scope.row.channelComTimes}}月</span></span>
                         </template>
                    </el-table-column>  
                    <el-table-column prop="goodsName" min-width="110" align="left" label="下游结算">
                        <template slot-scope="scope" >
                            <span class="red">￥{{scope.row.goodsCom}}<span v-if="scope.row.goodsComType==2"> * {{scope.row.goodsComTimes}} 月</span></span>
                         </template>
                    </el-table-column> 
                    <el-table-column prop="goodsName" min-width="100"   align="center" label="权重">
                        <template slot-scope="scope" >
                            <input v-model.trim="scope.row.weight" :disabled="config.edit" @change="handleVal(scope.row)"  placeholder="产品权重，0-10之间" class="inputStyle" style="width:100%;" oninput="value=value.replace(/[^0-9.]/g,'')"  > 
                           
                         </template>
                    </el-table-column>  
                    <el-table-column prop="status" align="center" v-if="query2.groupType==0" fixed="right" min-width="100" label="是否主推">
                        <template slot-scope="scope" > 
                            <p style="font-size:13px;line-height:30px;"> 
                                <el-tooltip :content="scope.row.master=='1'?'主品':'子品'" placement="top">
                                    <el-switch @change="handleStatus2(scope.row)" 
                                        v-model="scope.row.master"
                                        active-color=""
                                        inactive-color=""
                                        active-value="1"
                                        inactive-value="0">
                                    </el-switch>
                                </el-tooltip> 
                            </p>    
                        </template>  
                    </el-table-column>   
                    <el-table-column prop="status" align="center" fixed="right" min-width="100" label="组合状态">
                        <template slot-scope="scope" > 
                            <p style="font-size:13px;line-height:30px;"> 
                                <el-tooltip :content="scope.row.status=='1'?'已组合':'未组合'" placement="top">
                                    <el-switch @change="handleStatus(scope.row)" 
                                        v-model="scope.row.status"
                                        active-color=""
                                        inactive-color=""
                                        active-value="1"
                                        inactive-value="0">
                                    </el-switch>
                                </el-tooltip> 
                            </p>    
                        </template>  
                    </el-table-column>   
                     
                </el-table>  
                <div class="pagination">
                    <el-pagination  background layout="total,  sizes,prev, pager, next,jumper"
                        :page-sizes="[10,20]"
                        :current-page="query2.pageIndex"
                        :page-size="query2.pageSize"
                        :total="pageTotal2"
                        @size-change="handleSizeChange2"
                        @current-change="handlePageChange2" 
                    ></el-pagination>
                </div> 
            </div>  
        </div>
     

         
    </div>
 
</template> 

<script>
import $ from 'jquery' ; 
import bus from '../common/bus';   
import {fetchSelect as fetchSelect6} from '../../view/channel/channel';  //资源名称
import {fetchData,changeStatus,changeVal,changeStatus2} from '../../api/comGoodsGroupConfig'; 
export default {

    data() {
        return {   
            riskIndexs:[],
            goodsCode:'', 
            orderDis:true,
            config:{
                wid:'800px',
                top:'50px',
                edit:true,
            }, 
            select:{option:''},
            select6:{option:''},
            configVisible:false,
            contentVisible:false,
            sureImgVisible:false, 
            sureImgVisible2:false, 
            saveContent:'0',
            contentVal:'',
            infoVisible:false,
            loading:false,
            loading2:false,
            loading3:false, 
            loading4:false,  
            query2: { 
                pageIndex: 1,
                pageSize: 10,  
                goodsCode:'',
                groupType:'',
            },  
            select3:{
                option:'',
            },
            tableData: [],
            tableData2: [], 
            skuCodes:[], 
            form4:{}, 
            idx: -1,
            id: -1
        };
    },
 
    beforeDestroy() {
        // 记得移除监听，避免内存泄漏
        bus.$off('config-son');
    },
    created() { 
        
    },
    //页面加载方法
    mounted: function () { 
        
        bus.$on('config-son',  row  => { 
            this.query2.goodsCode = row.goodsCode; 
            this.query2.groupType = row.channelCode; 
            this.getSelect6(); 
            this.getData2();
            this.config.edit = true;
        });
        
    },
    

    methods: { 
        setEdit(){ 
            if(this.orderDis){
                this.orderDis = false;
            }else{
                this.orderDis = true;
            } 
        },
        setConfigEdit(){ 
            if(this.config.edit){
                this.$confirm('解开编辑权限后，修改的所有数据都将实时保存，确定要解开吗？', '提示', {
                    type: 'warning'
                }).then(() => {
                    this.config.edit = false;
                }) 
            }else{
                this.config.edit = true;
               
            }
        }, 
        handleVal(row){
            if(row.weight>10){
                this.$message.error(`权重值必须在 0-10之间`);
                return;
            }
            changeVal(row).then(res => {   
                if(res.code=='200'){ 
                    this.$notify({ title: '成功', message: row.goodsName+'设置成功',duration: 1000, type: 'success' });
                }else{
                    this.$notify({ title: '失败', message: row.goodsName+'设置失败：'+res.message,duration: 5000, type: 'error' }); 
                }
            });
        }, 
        setDeduc(row){
            if (!row.deducPercent) {
                row.deducPercent = 0;
            }
            if(row.deducPercent>100){
                this.$message.error(row.goodsName+'扣量值不能超过100');
                return;
            }
            setDeducPercent(row).then(res => {   
                if(res.code=='200'){  
                    this.getData2();
                    this.$notify({ title: '成功', message: row.loginName+'扣量值设置成功',duration: 1000, type: 'success' });
                }else{ 
                    this.$notify({ title: '失败', message:row.loginName+'扣量值设置失败：'+res.message,duration: 5000, type: 'error' });
                }
            }); 
        },
        configSet(row){      
            this.config.edit = true;
            this.$set(this.config, 'edit',true);   
            this.query2.goodsCode = row.goodsCode;   
            this.goodsConfig(row);
            this.getData2(); 
            this.configVisible = true; 
        }, 
        goodsConfig(row){
            getGoodsConfig(row).then(res => {   
                if(res.code=='200'){  
                    this.form4 = res.data; 
                }else{
                    this.$message.error(res.message); 
                }
            });  
        }, 
         
         
        setMemRiskConfig(row){
            if(row.riskNum<100){
                this.$message.error("渠道风控值不小于100！");
                return;
            }
            if(row.riskPercent>50){
                this.$message.error("渠道转化率不超过50%！");
                return;
            }
            setMemRisk(row).then(res => {   
                if(res.code=='200'){  
                    this.$notify({ title: '成功', message: '渠道:'+row.loginName+' 风控设置成功',duration: 1000, type: 'success' }); 
                }else{
                     this.$notify({ title: '失败', message: '渠道:'+row.loginName+' 风控设置失败：'+res.message,duration: 3000, type: 'error' });
                }
            });
        },
        handleStatus(row){
            var tips ;
            var content;
            if(row.status=='0'){ 
                row.status='1';
                tips = "移出组合"; 
            }else{ 
                row.status = '0';
                tips = "加入组合"; 
            }
            this.$confirm('确认将《'+row.goodsName+"》"+tips+'吗', '提示', {
                type: 'warning'
            }).then(() => {
                if(row.status=='0'){ 
                    row.status='1' 
                }else{ 
                    row.status='0' 
                }
                row.memId = row.mid;
                changeStatus(row).then(res => {   
                    if(res.code=='200'){  
                        this.getData2();
                        this.$notify({ title: '成功', message: row.goodsName+tips+'成功',duration: 1000, type: 'success' }); 
                    }else{
                        if(row.status=='0'){ 
                            row.status='1'   
                        }else{ 
                            row.status='0' 
                        }
                        this.$notify({ title: '失败', message: row.goodsName+tips+'失败：'+res.message,duration: 5000, type: 'error' });  
                    }
                });
            });
        },
        handleStatus2(row){ 
            var tips ;
            var content;
            if(row.master=='0'){ 
                row.master='1';
                tips = "取消主品设置"; 
            }else{ 
                row.master = '0';
                tips = "设置为主品"; 
            }
            if(row.status!=1){
                this.$message.error("该产品未加入组合");
                return;
            }
            this.$confirm('确认对《'+row.goodsName+"》"+tips+'吗', '提示', {
                type: 'warning'
            }).then(() => {
                if(row.master=='0'){ 
                    row.master='1' 
                }else{ 
                    row.master='0' 
                }
                row.memId = row.mid;
                changeStatus2(row).then(res => {   
                    if(res.code=='200'){   
                        this.getData2();
                        this.$notify({ title: '成功', message: row.goodsName+tips+'成功',duration: 1000, type: 'success' }); 
                    }else{
                        if(row.master=='0'){ 
                            row.master='1' 
                        }else{ 
                            row.master='0' 
                        }
                        this.$notify({ title: '失败', message: row.goodsName+tips+'失败：'+res.message,duration: 5000, type: 'error' }); 
                    }
                });
            });
        }, 

        handleStatus4(row){
            var tips ;
            var content;
            if(row.riskStatus=='0'){ 
                row.riskStatus='1';
                tips = "重启风控"; 
            }else{ 
                row.riskStatus = '0';
                tips = "风控关停"; 
            }
            this.$confirm('确认对《'+row.loginName+"》"+tips+'吗', '提示', {
                type: 'warning'
            }).then(() => {
                if(row.riskStatus=='0'){ 
                    row.riskStatus='1' 
                }else{ 
                    row.riskStatus='0' 
                }
                row.memId = row.mid;
                changeStatus4(row).then(res => {   
                    if(res.code=='200'){   
                        this.$notify({ title: '成功', message: row.loginName+tips+'成功',duration: 1000, type: 'success' }); 
                    }else{
                        if(row.riskStatus=='0'){ 
                            row.riskStatus='1' 
                        }else{ 
                            row.riskStatus='0' 
                        }
                        this.$notify({ title: '失败', message: row.loginName+tips+'失败：'+res.message,duration: 5000, type: 'error' });  
                    }
                });
            });
        }, 
        getSelect(){ 
            this.select = {}; 
            fetchSelect(this.select).then(res => {   
                if(res.code=='200'){ 
                    this.$set(this.select, 'option', res.data);  
                }
            });
        },
        getSelect6(){ 
            this.select6 = {};  
            fetchSelect6(this.select6).then(res => {   
                if(res.code=='200'){ 
                    this.$set(this.select6, 'option', res.data);  
                }
            });
        },
        
          
        refreshSearch2() {
            this.$set(this.query2, 'mids');
            this.$set(this.query2, 'giveType'); 
            this.$set(this.query2, 'isRisk' );  
            this.$set(this.query2, 'isDeduc');
            this.$set(this.query2, 'status');
            this.getData2();
        },
        handleSearch2(){
            this.$set(this.query2, 'pageIndex', 1);
            this.getData2();
        },
        getData2(){
            // 获取列表数据   
            this.loading4 = true;
            fetchData(this.query2).then(res => {  
                this.loading4 = false;
                if(res.code=='200'){ 
                    this.tableData2 = res.data.list;
                    this.pageTotal2 = res.data.pageTotal || 0;   
                }else{
                    this.tableData2 = []; 
                    this.pageTotal2 = 0;
                } 
                
            });
        },
          
         //刷新
        refresh(){
            history.go(0); 
        },
         
        // 多选操作
        handleSelectionChange(val) {
            this.multipleSelection = val; 
        },
         
         
        validateNumberInput(input) {
            // 使用正则表达式替换非数字和小数点的字符
            input.value = input.value.replace(/[^0-9.]/g, '');

            // 确保只有一个小数点
            let parts = input.value.split('.');
            if (parts.length > 2) {
                input.value = parts[0] + '.' + parts.slice(1).join('');
            }

            // 确保不以小数点开头
            if (input.value.startsWith('.')) {
                input.value = input.value.substring(1);
            }
        },
        
        // 分页导航
        handlePageChange2(val) { 
            this.$set(this.query2, 'pageIndex', val);
            this.getData2();
        },
        //分页数量更改导航
        handleSizeChange2(val){
            this.$set(this.query2, 'pageSize', val);
            this.getData2();
        }
    }
};
</script>
<style> 
.chm-imgUl{
   width:560px;height:250px;margin-top:15px;
}
.chm-imgLi{
    list-style: none;
    float:left;width:100px;
    padding:0 20px;
}
.chm-imgFag{
    font-size: 35px;
    color: #ccc;
    position: relative;
    top: -100px;
    left: 30px;
}
.chm-imgDiv{
     position: relative;width: 100px;height: 160px; margin-top:-200px;border: 1px solid #eee;border-radius: 5px;background-color:#eee;opacity:0;box-sizing: border-box;
}
.chm-imgInput{
     width: 100px; height: 160px; cursor: pointer; 
}
.chm-imgTip{
    width:100px;
    background:rgb(245, 105, 24);
    color:#fff;
    height:35px;
    font-size: 13px;
    line-height:35px;
    display:inline-block;
    text-align: center;;
    margin-top:10px;
}
.el-dialog__title{
    font-size: 15px;;
}
 
.el-upload-list--picture-card .el-upload-list__item{
    width:80px ;
    height:80px ;
}
.el-upload--picture-card{
    width:80px ;
    height:80px ;
    line-height:80px ;
}

.ql-container{
    min-height:150px; 
  }
.ql-editor{
	height: 150px;
}
.contentHei .ql-editor{
    height: 450px;
}
#input_box{
	height: 100px;
	padding: 0 10px;
	font-size: 12px;
	word-wrap:break-word;/*为了在ie和FF顺利换行，加上word-wrap*/
	overflow-x:hidden;
	overflow-y: auto; /*visible (默认), hidden, scroll, 和auto*/
	outline:none;
    border:1px solid #ddd;
    border-radius:5px;
    line-height: 15px;
}
#input_box2{
	height: 100px;
	padding: 0 10px;
	font-size: 12px;
	word-wrap:break-word;/*为了在ie和FF顺利换行，加上word-wrap*/
	overflow-x:hidden;
	overflow-y: auto; /*visible (默认), hidden, scroll, 和auto*/
	outline:none;
    border:1px solid #ddd;
    border-radius:5px;
    line-height: 15px;
}
#input_box3{
	height: 100px;
	padding: 0 10px;
	font-size: 12px;
	word-wrap:break-word;/*为了在ie和FF顺利换行，加上word-wrap*/
	overflow-x:hidden;
	overflow-y: auto; /*visible (默认), hidden, scroll, 和auto*/
	outline:none;
    border:1px solid #ddd;
    border-radius:5px;
    line-height: 15px;
}
.imgOper{
    margin-top: -45px; 
    font-size: 18px; 
    float: right;
    margin-right: 20px;
}
.imgOper span{
    margin-right:20px;
}
.imgOper i{
    margin-right:10px;
}
    .el-dialog__body{
        padding:10px 20px;
    }
    .el-dialog__footer{
        padding: 0px 20px 20px;
    }
    .overflowy{

    overflow-x: hidden; /* 设置溢出滚动 */
   white-space: nowrap;
   overflow-y: scroll;
   /* 隐藏滚动条 */
   scrollbar-width: none; /* firefox */
   -ms-overflow-style: none; /* IE 10+ */
}
.overflowy::-webkit-scrollbar {
    display: none; /* Chrome Safari */
 
}
</style>
<style scoped> 
.layerDiv{
    position:fixed;
    height:200px;
    background: #333;
    opacity:0.7;
    z-index:100;
}
.input{
    width:80px;height:27px;line-height:27px;text-align:center;color:#ff2222;border:1px solid #aaa;border-radius:5px;font-weight:700 
}
.input:focus {
    outline:none;
    border: 1px solid #fb8a11;
}
.redSpan{
    width:80px;height:30px;line-height:30px;display:inline-block;text-align:center;color:#ff2222;font-weight:700 
}
.titleInfo{
    width:100%;
    text-align: center;
    line-height: 30px;
    height: 30px;
    font-size: 14px;
    color:#fff; 
    background:#0094d8;
    margin:-10px 0 10px 0; 
}
.handle-box {
    width:100%;
    margin-bottom: 20px;
    overflow-x:auto;
}

.handle-select {
    margin-bottom:5px;
    width: 120px;
    display: inline-block;
}

.handle-input {
    margin-bottom:5px;
    width: 180px;
    display: inline-block;
}
.handle-del {
    float:right; 
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

/**/
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
@media screen and (max-width:999px){ 
  
 .goodDetails{
        font-size:12px;line-height:15px;height:18px;overflow-y:auto;
    }
    .goodRight{
        display:block;
    }
} 
@media screen and (min-width:999px){ 
    .goodDetails{
        font-size:15px;line-height:20px;height:22px;overflow-y:auto;
    }
    .goodRight{
        position:absolute;
        left:130px;
    }
}

.inputStyle{
    height:28px; 
    text-align:center; 
    border:none;
    border-bottom:1px solid orange; 
    background: none;
    color:orange;
}
.inputStyle::placeholder{
    color:#bbb;
}
.inputStyle:focus {
    outline:none;
    border-bottom:2px solid red; 
}

</style>
